export default __webpack_public_path__ + "static/media/Group 10498.292011c6.png";